import { useQuery } from "react-query";
import { getAllUsersQuery } from "ui-io/queries/tasks/task-user-list-query";
import { USERS_TEAMS } from "../utils/admin-io";
// import useSession from 'ui-io/use-session'

const useUserList = (isBulkView: boolean = true) => {
  // const { session } = useSession()
  // const env = session?.environment === 'prod' ? 'prod' : 'staging'
  const userList = useQuery(
    getAllUsersQuery({ team: USERS_TEAMS.YANTRIX_ADMIIN_ALL })
  );
  return userList.data;
};
export default useUserList;
